// extracted by mini-css-extract-plugin
module.exports = {"food":"_3S842zAxl0kbv6vZNA-lfQ","image":"SFnkwPg9Ry2hPegx3IQPQ"};